// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lugia: PokeData = {
  "id": 249,
  "name": "lugia",
  "height": 52,
  "weight": 2160,
  "base_experience": 306,
  "types": [
    PokeType.PSYCHIC,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "mist",
    "hydro-pump",
    "recover",
    "swift",
    "sky-attack",
    "aeroblast",
    "safeguard",
    "rain-dance",
    "ancient-power",
    "future-sight",
    "weather-ball",
    "extrasensory",
    "calm-mind",
    "natural-gift",
    "punishment",
    "dragon-rush"
  ],
  "moves": [
    "gust",
    "hydro-pump",
    "sky-attack",
    "rain-dance",
    "ancient-power",
    "future-sight",
    "calm-mind",
    "dragon-rush",
    "aerial-ace",
    "psy-ball",
    "acrobatics",
    "psywave",
    "peck"
  ],
  "evolution_chain": {
    "id": 127,
    "item": null,
    "species": [
      {
        "name": "lugia",
        "order": 274,
        "types": [
          PokeType.PSYCHIC,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 136,
    "ability_power": 111
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
